<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <span class="version">{{environment.version}} © Sarraf</span> 
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by <a style="color: #74788d !important" href="https://znosoft.net/">ZNOSoft</a>
                </div>
            </div>
        </div>
    </div>
</footer>